import { createSlice } from "@reduxjs/toolkit";
import { disbursementsReducer } from "./reducer";
import { initialState } from "./initialState";
import { addDisbursementsAction, approveDisbursementAction, editDisbursementsAction, getDisbursementsListAction, getSharedDisbursementsListAction, getSingleDisbursementAction } from "./actions";
import { DisbursementsType } from "./disbursementsType";

export const disbursementsSlice = createSlice({
    name: 'disbursementss',
    initialState,
    reducers: disbursementsReducer,
    extraReducers: {
        [getDisbursementsListAction.pending.toString()]: (state: DisbursementsType) => ({
            ...state,
            fetching: true
        }),
        [getDisbursementsListAction.fulfilled.toString()]: (state: DisbursementsType, { payload }) => {
            const { success, message, result, status_code} = payload;
            if (success === 0) {
                return {
                    ...state,
                    fetching: false,
                    error: message,
                    statusCode: status_code,
                    success
                }
            }
            return {
                ...state,
                fetching: false,
                disbursementsList: result?.data,
                totalCount:result?.total_count,
                totalAmount:result?.total_amount,
                remainingAmount:result?.remaining_amount,
            }
        },
        [getDisbursementsListAction.rejected.toString()]: (state: DisbursementsType, { error }) => ({
            ...state,
            fetching: false,
            success: 0,
            error: error.message

        }),
        [getSharedDisbursementsListAction.pending.toString()]: (state: DisbursementsType) => ({
            ...state,
            fetching: true
        }),
        [getSharedDisbursementsListAction.fulfilled.toString()]: (state: DisbursementsType, { payload }) => {
            const { success, message, result, status_code} = payload;
            if (success === 0) {
                return {
                    ...state,
                    fetching: false,
                    error: message,
                    statusCode: status_code,
                    success
                }
            }
            return {
                ...state,
                fetching: false,
                sharedDisbursementList: result?.data,
                totalSharedCount:result?.total_count,
                totalAmount:result?.total_amount,
                remainingAmount:result?.remaining_amount,
            }
        },
        [getSharedDisbursementsListAction.rejected.toString()]: (state: DisbursementsType, { error }) => ({
            ...state,
            fetching: false,
            success: 0,
            error: error.message

        }),
        [getSingleDisbursementAction.pending.toString()]: (state: DisbursementsType) => ({
            ...state,
            fetching: true
        }),
        [getSingleDisbursementAction.fulfilled.toString()]: (state: DisbursementsType, { payload }) => {
            const { success, message, result, status_code} = payload;
            if (success === 0) {
                return {
                    ...state,
                    fetching: false,
                    error: message,
                    statusCode: status_code,
                    success
                }
            }
            return {
                ...state,
                fetching: false,
                singleDisbursement: result
            }
        },
        [getSingleDisbursementAction.rejected.toString()]: (state: DisbursementsType, { error }) => ({
            ...state,
            fetching: false,
            success: 0,
            error: error.message

        }),
        [editDisbursementsAction.pending.toString()]: (state: DisbursementsType) => ({
            ...state,
            fetching: true
        }),
        [editDisbursementsAction.fulfilled.toString()]: (state: DisbursementsType, { payload }) => {
            const { success, message,status_code } = payload;
            if (success === 0) {
                return {
                    ...state,
                    fetching: false,
                    error: message,
                    statusCode: status_code,
                    success
                }
            }
            return {
                ...state,
                fetching: false,
                success
            }
        },
        [editDisbursementsAction.rejected.toString()]: (state: DisbursementsType, { error }) => ({
            ...state,
            fetching: false,
            success: 0,
            error: error.message

        }),
        [addDisbursementsAction.pending.toString()]: (state: DisbursementsType) => ({
            ...state,
            fetching: true
        }),
        [addDisbursementsAction.fulfilled.toString()]: (state: DisbursementsType, { payload }) => {
            const { success, message, status_code } = payload;
            if (success === 0) {
                return {
                    ...state,
                    fetching: false,
                    error: message,
                    statusCode: status_code,
                    success
                }
            }
            return {
                ...state,
                fetching: false,
                success
            }
        },
        [addDisbursementsAction.rejected.toString()]: (state: DisbursementsType, { error }) => ({
            ...state,
            fetching: false,
            success: 0,
            error: error.message
        }),
        [approveDisbursementAction.pending.toString()]: (state: DisbursementsType) => ({
            ...state,
            fetching: true
        }),
        [approveDisbursementAction.fulfilled.toString()]: (state: DisbursementsType, { payload }) => {
            const { success, message, status_code } = payload;
            if (success === 0) {
                return {
                    ...state,
                    fetching: false,
                    error: message,
                    statusCode: status_code,
                }
            }
            return {
                ...state,
                fetching: false,
                approvalMessage:message,
                approvalSuccess:success
            }
        },
        [approveDisbursementAction.rejected.toString()]: (state: DisbursementsType, { error }) => ({
            ...state,
            fetching: false,
            success: 0,
            error: error.message

        }),
    }
})
export const {
    resetDisbursementsSuccess,
    resetDisbursementsError,
    resetDisbursementsMessage,
    resetDisbursementsStatusCode,
    resetDisbursementList,
    resetSingleDisbursement,
    resetApprovalMessage,
    resetApprovalSuccess,
    resetTotalCount,
    resetSharedDisbursementList,
    resetTotalSharedCount,
    resetDisbursmentFetching,
    resetTotalAmount,
    resetRemainingAmount
} = disbursementsSlice.actions